module.exports = __webpack_public_path__ + "a81a33d7c89f2a245c74d03c74dbe005.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/target_2022_chart.png
// module id = 1742
// module chunks = 0